<template>
  <v-card>
    <v-card-title>
      Reset device authorization
    </v-card-title>
    <v-card-text>
      <v-row justify="center">
        <canvas
          ref="myCanvas"
          id="myCanvas"
          width="400"
          height="400"
        ></canvas>
      </v-row>
      <v-row justify="center">
        <p>
          {{deviceRegistrationCode}}
        </p>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="cancel">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import QRCode from 'qrcode';
import gql from 'graphql-tag';

const UPDATE_DEVICE = gql`
  mutation addDeviceRegistrationCode ($id: String!, $deviceRegistrationCode: String) {
    update_devices_by_pk(
      pk_columns: { id: $id }
      _set: { code: $deviceRegistrationCode }
    ) {
      id
      code
      serial
      firmware
      name
      description
      user_id
    }
  }
`;

export default {
  name: 'AuthorizeDeviceDialog',
  props: {
    id: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    reAuthorizeDevice: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      deviceRegistrationCode: this.code,
    };
  },
  watch: {
    code: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler(val) {
        if (val) {
          this.deviceRegistrationCode = val;
          this.updateDeviceRegistrationCode();
        }
      },
    },
  },
  mounted() {
    /* TODO
      1) update code to backend and subscribe to updates
      2) if succesful create QR and start timer
      a) receive update --> Device got token --> close dialog
      b) time out --> remove code from backend and close dialog
      b) cancel --> remove code from backend and close dialog
    */
    this.convert();
  },
  computed: {

  },
  methods: {
    async cancel() {
      const { id } = this;
      const deviceRegistrationCode = null;
      await this.$apollo.mutate({
        mutation: UPDATE_DEVICE,
        variables: {
          id,
          deviceRegistrationCode,
        },
      });
      this.$emit('update:reAuthorizeDevice', false);
    },
    async updateDeviceRegistrationCode() {
      const { deviceRegistrationCode, id } = this;

      await this.$apollo.mutate({
        mutation: UPDATE_DEVICE,
        variables: {
          id,
          deviceRegistrationCode,
        },
      });
      // Create QR Code
      this.convert();
    },
    convert() {
      QRCode.toCanvas(
        this.$refs.myCanvas,
        this.deviceRegistrationCode,
        { width: 400, height: 400 },
        (error) => {
          if (error) console.error(error);
        },
      );
    },
  },
};
</script>
